import { render, staticRenderFns } from "./EditImovelPage.vue?vue&type=template&id=fbb742d2"
import script from "./EditImovelPage.vue?vue&type=script&lang=js"
export * from "./EditImovelPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports